import { type Component, Show, createEffect, createSignal } from "solid-js";
import { currentText, metrics, phase } from "../lib/store.ts";

function escHtml(s: string): string {
  return s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}

const Caption: Component = () => {
  const [popClass, setPopClass] = createSignal("");

  // Trigger pop-in animation on new text
  createEffect(() => {
    const text = currentText();
    if (!text) return;
    setPopClass(""); // reset
    // Force reflow by deferring
    requestAnimationFrame(() => setPopClass("pop-in"));
  });

  const isInferring = () => phase() === "inferring";
  const isDone = () => !!currentText() && !isInferring();

  return (
    <div id="center-text">
      <div
        id="live-text"
        classList={{
          [popClass()]: popClass().length > 0,
          visible: isDone(),
        }}
        innerHTML={
          isInferring()
            ? (currentText() ? escHtml(currentText()) : "") +
              '<span class="cursor"></span>'
            : currentText()
              ? escHtml(currentText())
              : ""
        }
      />

      <Show when={metrics()}>
        {(m) => (
          <div
            id="center-metrics"
            classList={{ show: !isInferring() }}
          >
            <div class="metric">
              <span class="num">{m().tokens}</span>
              <span class="lbl">tokens</span>
            </div>
            <div class="metric">
              <span class="num">{m().elapsed.toFixed(2)}</span>
              <span class="lbl">seconds</span>
            </div>
            <div class="metric">
              <span class="num">{m().tokPerSec.toFixed(1)}</span>
              <span class="lbl">tok/s</span>
            </div>
          </div>
        )}
      </Show>
    </div>
  );
};

export default Caption;
